<template>
  <div class="m-3" style="height: 90vh">
    <ReportsTable ref="rtable" :columns="columnDefs" :settings="{title: t('employeeAttendance')}" endpoint="reports/hr/employee-attendance">
      <template #filter>
        <el-select
          filterable
          clearable
          class="col-span-12 md:col-span-3"
          value-key="fullName"
          :placeholder="t('selectEmployee')"
          v-model="selectedEmployee"
          @change="onSelectedEmployeeChanged"
          remote
          :remote-method="searchEmployees"
        >
          <el-option
            v-for="option in employees"
            :key="option.id"
            :label="option.fullName"
            :value="option"
          ></el-option>
        </el-select>
      </template>
    </ReportsTable>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, provide } from 'vue'
import { useI18n } from 'vue-i18n'
import { ColDef } from 'ag-grid-community'
import { useRoute, useRouter } from 'vue-router'
import { useHTTP } from '@/plugins/http'
import { useAlertModal } from '@/plugins/alert-modal/alert-modal'
import { formatMoney } from '@/utils/money'
import ReportsTable from '@/views/reports/v2/table/ReportsTable.vue'
import { formatPostgresDate } from '@/utils/date'
import User from '@/models/user/User'

// i18n
const { t } = useI18n({
  messages: {
    en: {
      employeeAttendance: 'Employee Attendance',
      employee: 'Employee',
      timeIn: 'Time In',
      timeOut: 'Time Out',
      totalHours: 'Total Hours',
      selectEmployee: 'Select Employee',
    },
    ar: {
      employeeAttendance: 'حضور الموظفين',
      employee: 'الموظف',
      timeIn: 'وقت الدخول',
      timeOut: 'وقت الخروج',
      totalHours: 'مجموع الساعات',
      selectEmployee: 'اختر الموظف',
    }
  }
})

// Data
const rtable = ref<any>()
const columnDefs = ref<ColDef[]>([])

const http = useHTTP()
const route = useRoute()
const router = useRouter()
const alertModal = useAlertModal()

const employees = ref<User[] | any>();
const selectedEmployee = ref<any>()

onBeforeMount(async () => {
  columnDefs.value = [
    {
      headerName: t('employee'),
      field: 'employee_name',
      checkboxSelection: true,
      headerCheckboxSelection: true
    },
    {
      headerName: t('models.common.date'),
      valueFormatter: ({ data }) => {
        if (!data) return ''
        return `${formatPostgresDate(data.clock_date, 'DD/MM/YYYY')}`
      }
    },
    {
      headerName: t('timeIn'),
      field: 'time_in',
      cellStyle: { direction: 'ltr' }
    },
    {
      headerName: t('timeOut'),
      field: 'time_out',
      cellStyle: { direction: 'ltr' }
    },
    {
      headerName: t('totalHours'),
      field: 'total_hours',
      cellStyle: { direction: 'ltr' }
    }
  ]
})


async function onSelectedEmployeeChanged(event: any) {
  rtable.value.payload.filter = selectedEmployee.value? selectedEmployee.value.id: null;
  rtable.value.navigate(rtable.value.payload)
}

async function searchEmployees(query: string) {
  if (!query) {
    query = ''
  }
  try {
    const url = `${User.ENDPOINT}?q=${query}`
    const employeesRes = await http.get<User[]>(url)
    employees.value = employeesRes.map((employee) => User.from(employee))
  } catch (error) {
    employees.value = []
  }
}
</script>
